import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";

const stat = (require("../data/docs-statuscodes.json")).data;

export default function TeamCredOverview(props) {

  const data = props.data
  const {id} = useParams();

  return (
    <>
    <div className="">

      <div className="d-flex">
        <div className="me-auto">
          <ViewSectionName data={data.name}/>
        </div>
        <div className="py-3">
          <span className={`badge rounded-pill p-2 px-3 bg-${stat[data.stat].colr}`}>
            <small>{stat[data.stat].text}</small>
          </span>
        </div>
      </div>
      
      <div className="p-3 bg-white rounded-top border">

        <div className="d-flex">
          <div className="me-auto">
            <p className="lead text-primary m-0 p-0">{'Number: '}{data.nmbr}</p>
            <p className="lead fw-bold m-0 p-0">{data.user}</p>
            <p className="small m-0 p-0">{'ID: '}{data.enid}</p>
            <p className="small m-0 p-0">
              <span>{'Start: '}{data.stts}</span>
              <span>{' / '}</span>
              <span>{'End: '}{data.ents}</span>
            </p>

          </div>

          <div className="">
            <Link to={'/bz/team/edit/'+id} 
              className="btn btn-outline-primary border-none btn-light px-3">
              <small>Edit</small>
            </Link>
          </div>

        </div>

        
      </div>
      <div className={`py-2 small text-center bg-dark text-white ${data.blck?'':'d-none'}`}>Blacklisted</div>

      <div className="layout-landscape rounded-bottom border mb-3">
        <img src={data.file} alt='...' className='img-fluid'></img>
      </div>

      <div className="mb-3"></div>
      
    </div>
    </>
  )
}